/**
 * Read from the environment rather than committed inline (as the FireCMS
 * template does) so a fork of this repo cannot accidentally point the admin UI
 * at our project.
 *
 * Missing values surface as FireCMS's `configError` screen — an explicit
 * message, not a blank page.
 */
export const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
};
